module.exports = __webpack_public_path__ + "static/img/race1.ab3f231.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/race1.png
// module id = I8uj
// module chunks = 1 3